import React from 'react';
import { Controlled as CodeMirror } from 'react-codemirror2';
import { useState } from 'react';

import 'codemirror/lib/codemirror.css';

import 'codemirror/mode/css/css';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/javascript/javascript';

import './code-editor.css';
import { CompiledCode } from '../compiled/compiled-code';

export const CodeEditor = (props) => {
  const { css, html, js, defaultTab } = props;

  const [tab, setTab] = useState(defaultTab);

  const [cssValue, setCSSValue] = useState(css.initial);
  const [htmlValue, setHTMLValue] = useState(html.initial);
  const [jsValue, setJSValue] = useState(js.initial);

  const onChangeCSS = (newValue) => setCSSValue(newValue);
  const onChangeHTML = (newValue) => setHTMLValue(newValue);
  const onChangeJS = (newValue) => setJSValue(newValue);

  return (
    <div className="code-editor">
      <div className="code-editor-left">
        <div className="editor-tabs">
          <div onClick={() => setTab('html')} className={tab === 'html' ? 'active' : ''}>HTML</div>
          <div onClick={() => setTab('css')} className={tab === 'css' ? 'active' : ''}>CSS</div>
        </div>
        {tab === 'html' && <CodeMirror 
          className="editor"
          value={htmlValue}
          options={{
            mode: 'htmlmixed',
            lineNumbers: true
          }}
          onBeforeChange={(editor, data, newValue) => onChangeHTML(newValue)}
        />}
        {tab === 'css' && <CodeMirror 
          className="editor"
          value={cssValue}
          options={{
            mode: 'css',
            lineNumbers: true
          }}
          onBeforeChange={(editor, data, newValue) => onChangeCSS(newValue)}
        />}
        {tab === 'js' && <CodeMirror 
          className="editor"
          value={jsValue}
          options={{
            mode: 'js',
            lineNumbers: true
          }}
          onBeforeChange={(editor, data, newValue) => onChangeJS(newValue)}
        />}
      </div>
      <div className="code-editor-right">
        <CompiledCode css={cssValue} html={htmlValue} js={jsValue}/>
      </div>
    </div>
  );
}

